<span class="rooms-text">{{ 'SELECT-QUANTITY-ROOMS' | translate }}</span>
<span class="dropdown-title">{{ currentNumber }}</span>
<div *ngIf="building" class="filter-title numberOfRooms-title" [class.disabled-filters]="building.showRoomsSwitcher.length < 3">{{ 'ROOMS' | translate }}:</div>
<ul class="num-of-rooms sub-menu-content" *ngIf="building" [class.disabled-filters]="building.showRoomsSwitcher.length < 3">
  <li (click)="howMuchRooms(numRooms, $event)"
    *ngFor="let numRooms of building.showRoomsSwitcher | sortNumberArray: '': true" [class.current]="+currentNumber === +numRooms">
    {{ numRooms }} <span *ngIf="numRooms === ''">{{ 'ALL'| translate }}</span>
  </li>
</ul>
